'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  margin-right: auto;\n  margin-left: auto;\n\n  ', '\n\n  ', '\n'], ['\n  margin-right: auto;\n  margin-left: auto;\n\n  ', '\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    padding-right: ', ';\n    padding-left: ', ';\n  '], ['\n    padding-right: ', ';\n    padding-left: ', ';\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    ', '\n  '], ['\n    ', '\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n        width: ', 'rem;\n      '], ['\n        width: ', 'rem;\n      ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _createProps = require('../createProps');

var _createProps2 = _interopRequireDefault(_createProps);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Grid = function Grid(props) {
  return _react2.default.createElement(props.tagName || 'div', (0, _createProps2.default)(Grid.propTypes, props));
};

Grid.displayName = 'Grid';

Grid.propTypes = {
  fluid: _propTypes2.default.bool,
  tagName: _propTypes2.default.string,
  children: _propTypes2.default.node
};

exports.default = (0, _styledComponents2.default)(Grid)(_templateObject, function (p) {
  return p.fluid && (0, _styledComponents.css)(_templateObject2, function (p) {
    return (0, _config2.default)(p).outerMargin + 'rem';
  }, function (p) {
    return (0, _config2.default)(p).outerMargin + 'rem';
  });
}, function (p) {
  return !p.fluid && (0, _styledComponents.css)(_templateObject3, _config.DIMENSION_NAMES.map(function (t) {
    return (0, _config2.default)(p).container[t] && (0, _config2.default)(p).media[t](_templateObject4, function (p) {
      return (0, _config2.default)(p).container[t];
    });
  }));
});


//////////////////
// WEBPACK FOOTER
// ./~/react-styled-flexboxgrid/lib/components/Grid.js
// module id = 345
// module chunks = 0